import GoogleSvg from 'src/assets/login/googleLogo.svg';
const TATE_HOSTNAME = ['test-chat.trsai.cn', 'pre-chat.tate-a-tate.com', 'chat.tate-a-tate.com', 'localhost:3001'];

// 获取用户协议地址
const getUserAgreementUrl = () => {
  let url = 'https://console.tate-a-tate.com/login/en/userAgreement'; // 线上
  if (process.env.REACT_APP_ENV === 'dev') { // 开发
    url = 'https://test-console.trsai.cn/login/en/userAgreement';
  }
  if (process.env.REACT_APP_ENV === 'test') { // 测试
    url = 'https://test-console.trsai.cn/login/en/userAgreement';
  }
  if (process.env.REACT_APP_ENV === 'pre') { // 灰度
    url = 'https://pre-console.tate-a-tate.com/login/en/userAgreement';
  }
  return url;
};

// 获取隐私协议地址
const getPrivacyAgreementUrl = () => {
  let url = 'https://console.tate-a-tate.com/login/en/privacyAgreement'; // 线上
  if (process.env.REACT_APP_ENV === 'dev') { // 开发
    url = 'https://test-console.trsai.cn/login/en/privacyAgreement';
  }
  if (process.env.REACT_APP_ENV === 'test') { // 测试
    url = 'https://test-console.trsai.cn/login/en/privacyAgreement';
  }
  if (process.env.REACT_APP_ENV === 'pre') { // 灰度
    url = 'https://pre-console.tate-a-tate.com/login/en/privacyAgreement';
  }
  return url;
};

export {
  GoogleSvg,
  TATE_HOSTNAME,
  getUserAgreementUrl,
  getPrivacyAgreementUrl
};
